<template>
  <div>
    <v-card class="main">
      <v-toolbar dense class="elevation-2">
        <v-toolbar-title class="body-2 beez-bold">
          Tulip Maintenance
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <v-expansion-panel>
          <v-expansion-panel-content v-if="can('PREFERENCE_MAINTENANCE')">
            <template slot="header">
              <div class="body-2">
                <v-icon class="pr-3">settings</v-icon>
                Maintenance
              </div>
            </template>
            <v-card>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="body-2"
                      >Clean Up Runtime queues |
                      <a @click.stop="getRuntimeQueues">
                        Get Total Runtime Queues: {{ runtimeQueueCount }}</a
                      >
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      This will fix clear the Dynamic Runtime Queues which got
                      created as part of the Workflow execution and not cleared
                      by the Auto-Queue clearing logic.
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :outline="$vuetify.dark"
                      :color="$vuetify.dark ? 'secondary' : ''"
                      :class="!$vuetify.dark ? 'secondary' : ''"
                      icon
                      flat
                      @click="cleanUpQueue"
                      :loading="getCountLoader || cleanCountLoader"
                    >
                      <v-icon>
                        delete_sweep
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="body-2"
                      >Delete Duplicate Profile Audit entries
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      This will clear the duplicate entries present in profile
                      audit tables while adding profiles to rules.
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :outline="$vuetify.dark"
                      :color="$vuetify.dark ? 'secondary' : ''"
                      :class="!$vuetify.dark ? 'secondary' : ''"
                      icon
                      flat
                      @click="deleteDuplicateProfiles"
                      :loading="deleteDuplicateLoader"
                    >
                      <v-icon>
                        delete_sweep
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="body-2"
                      >Run maintain checks on Execution KPIs
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      This will fix the erroneous KPI calculations.
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :outline="$vuetify.dark"
                      :color="$vuetify.dark ? 'secondary' : ''"
                      :class="!$vuetify.dark ? 'secondary' : ''"
                      icon
                      flat
                      @click="runKPIMaintenance"
                      :loading="kpiMaintainenceLoader"
                    >
                      <v-icon>
                        repeat
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="body-2"
                      >Initialize default tenant
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      Initialize default tenant
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :outline="$vuetify.dark"
                      :color="$vuetify.dark ? 'secondary' : ''"
                      :class="!$vuetify.dark ? 'secondary' : ''"
                      icon
                      flat
                      @click="syncTulipTenant"
                      :loading="syncTulipTenantLoader"
                    >
                      <v-icon>
                        auto_fix_normal
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="body-2"
                      >Check and fix Generic Accounts Sync-up Issues
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      This will fix the Generic Accounts specific Tulip Sync-up
                      issues if any present between Tulip services.
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :outline="$vuetify.dark"
                      :color="$vuetify.dark ? 'secondary' : ''"
                      :class="!$vuetify.dark ? 'secondary' : ''"
                      icon
                      flat
                      @click="syncTulipGenericUser"
                      :loading="syncTulipGenericUserLoader"
                    >
                      <v-icon>
                        sync_alt
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="body-2"
                      >Set system under maintenance
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      This will put system under maintenance, this will block
                      all users from logging in except 'support'.
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :outline="$vuetify.dark"
                      :class="tulipMaintenance ? 'secondary' : ''"
                      icon
                      flat
                      @click="setUnderMaintenance"
                      :loading="setUnderMaintenanceLoader"
                    >
                      <v-icon>
                        engineering
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="body-2"
                      >Block support user login
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      This will block 'support' user from logging in
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :outline="$vuetify.dark"
                      :class="blockSupport ? 'secondary' : ''"
                      icon
                      flat
                      @click="setSupportBlock"
                      :loading="setSupportBlockLoader"
                    >
                      <v-icon>
                        block
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="body-2">
                      Clear DMS cache for older items
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      Clear DMS cache for all items older than the 10 days.
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :outline="$vuetify.dark"
                      icon
                      flat
                      @click="cleanDMSCache"
                      :loading="cleanDMSCacheLoader"
                    >
                      <v-icon>
                        delete_sweep
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="body-2">
                      Migrate legacy jobs
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      Migrate all legacy jobs to new job system
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :outline="$vuetify.dark"
                      icon
                      flat
                      @click="migrateLegacyJobs"
                      :loading="migrateLegacyJobsLoader"
                    >
                      <v-icon>
                        fast_forward
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-if="can('MENU_SYNC_FIX')">
            <template slot="header">
              <div class="body-2">
                <v-icon class="pr-3">build</v-icon>
                Sync-Up Issues
              </div>
            </template>
            <sync-up-fix></sync-up-fix>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-if="can('MENU_USER_SESSION')">
            <template slot="header">
              <div class="body-2">
                <v-icon class="pr-3">build</v-icon>
                User Session History
              </div>
            </template>
            <UserSession></UserSession>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-if="can('MENU_LOGIN_ATTEMPTS')">
            <template slot="header">
              <div class="body-2">
                <v-icon class="pr-3">build</v-icon>
                Failed Login Attempts
              </div>
            </template>
            <login-attempts></login-attempts>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-if="can('MENU_TASK_SYNC_FIX')">
            <template slot="header">
              <div class="body-2">
                <v-icon class="pr-3">build</v-icon>
                Task Sync Admin
              </div>
            </template>
            <TaskSyncAdmin></TaskSyncAdmin>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import SyncUpFix from '@/components/user-management/SyncUpFix'
import UserSession from '@/components/user-management/UserSession'
import LoginAttempts from '@/components/user-management/LoginAttempts.vue'
import TaskSyncAdmin from '@/components/admin/TaskSyncAdmin'
import axios from 'axios'

export default {
  name: 'TulipMaintenance',
  components: {
    SyncUpFix,
    TaskSyncAdmin,
    UserSession,
    LoginAttempts
  },
  data() {
    return {
      search: '',
      cleanCountLoader: false,
      cleanDMSCacheLoader: false,
      migrateLegacyJobsLoader: false,
      getCountLoader: false,
      kpiMaintainenceLoader: false,
      deleteDuplicateLoader: false,
      syncTulipGenericUserLoader: false,
      syncTulipTenantLoader: false,
      setUnderMaintenanceLoader: false,
      setSupportBlockLoader: false,
      blockedIPLoader: false,
      headers: [
        {
          text: 'IP',
          align: 'left',
          value: 'ip'
        },
        { text: 'Attempt', value: 'attempt' },
        { text: 'Action', value: 'action' }
      ]
    }
  },
  mounted() {
    this.initLoad()
  },
  computed: {
    ...mapState({
      runtimeQueueCount: state => state.admin.runtimeQueueCount,
      blockedIP: state => state.admin.blockedIP,
      tulipMaintenance: state => state.admin.tulipMaintenance,
      blockSupport: state => state.admin.blockSupport
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  methods: {
    initLoad() {
      this.$store.dispatch('getTulipUnderMaintenance')
      this.$store.dispatch('getBlockedSupport')
    },
    migrateLegacyJobs() {
      this.migrateLegacyJobsLoader = true
      axios
        .post('/api/v1/jobSchedules/migrate')
        .then(response => {
          this.$store.dispatch('directNotification', {
            type: 'success',
            message: 'Legacy jobs migrated successfully',
            description: 'Legacy jobs migrated successfully',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
          this.migrateLegacyJobsLoader = false
        })
        .catch(error => {
          this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Unable to migrate legacy jobs',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
            description: error.response
              ? error.response.data.message
              : 'Error unknown! Kindly retry'
          })
          this.migrateLegacyJobsLoader = false
        })
    },
    async cleanDMSCache() {
      this.cleanDMSCacheLoader = true
      try {
        await this.$store.dispatch('cleanDMSCache')
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'DMS cache cleaned up successfully',
          description: 'DMS caches older than 10 days cleaned up successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to clean DMS Caches',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.cleanDMSCacheLoader = false
    },
    async cleanUpQueue() {
      this.cleanCountLoader = true
      try {
        await this.$store.dispatch('cleanUpRuntimeQueues')
        await this.getRuntimeQueues()
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Runtime Queues cleaned up successfully',
          description: 'Runtime Queues cleaned up successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to clean Runtime Queues',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.cleanCountLoader = false
    },
    async getRuntimeQueues() {
      this.getCountLoader = true
      try {
        await this.$store.dispatch('fetchRuntimeQueueCount')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to get Runtime Queue count',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.getCountLoader = false
    },
    async getBlockedIP() {
      this.blockedIPLoader = true
      try {
        await this.$store.dispatch('fetchBlockedIP')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to get blocked IP List',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.blockedIPLoader = false
    },
    async releaseBlockedIP(ip) {
      this.blockedIPLoader = true
      try {
        await this.$store.dispatch('unBlockIP', ip)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: `Unable to unblocked IP ${ip}`,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.blockedIPLoader = false
    },
    async runKPIMaintenance() {
      this.kpiMaintainenceLoader = true
      try {
        await this.$store.dispatch('maintainKPIs')
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Execution KPI maintenance Job completed',
          description: 'Execution KPI maintenance Job completed successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Execution KPI maintenance Job execution failed',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.kpiMaintainenceLoader = false
    },

    async deleteDuplicateProfiles() {
      this.deleteDuplicateLoader = true
      try {
        await this.$store.dispatch('deleteDuplicateProfiles')
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Duplicate Delete of Profile completed',
          description:
            'Execution of deleting duplicate profile entries got completed successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Execution of deleting duplicate profile entries failed',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.deleteDuplicateLoader = false
    },

    async syncTulipGenericUser() {
      this.syncTulipGenericUserLoader = true
      try {
        await this.$store.dispatch('syncTulipGenericUser')
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message:
            'Tulip Generic accounts Sync-Up Issue correction Job completed',
          description:
            'Tulip Generic accounts Sync-Up Issue correction Job completed successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Tulip Generic accounts Sync-Up Issue correction Job failed',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.syncTulipGenericUserLoader = false
    },

    async syncTulipTenant() {
      this.syncTulipTenantLoader = true
      try {
        await this.$store.dispatch('syncTulipTenantCreation')
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Default Tenant initialization completed',
          description: 'Default Tenant initialization completed successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Default Tenant initialization failed',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.syncTulipTenantLoader = false
    },

    async setUnderMaintenance() {
      this.setUnderMaintenanceLoader = true
      try {
        await this.$store.dispatch('setTulipUnderMaintenance', {
          value: !this.tulipMaintenance
        })
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Tulip maintenance activity successful',
          description: 'Tulip maintenance activity completed successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        await this.$store.dispatch('getTulipUnderMaintenance')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Tulip maintenance activity failed',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.setUnderMaintenanceLoader = false
    },

    async setSupportBlock() {
      this.setSupportBlockLoader = true
      try {
        await this.$store.dispatch('setSupportUserBlock', {
          value: !this.blockSupport
        })
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Tulip maintenance activity successful',
          description: 'Tulip maintenance activity completed successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        await this.$store.dispatch('getBlockedSupport')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Tulip maintenance activity failed',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      this.setSupportBlockLoader = false
    }
  }
}
</script>

<style scoped></style>
